<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <app-sub-header :title="title" @update:filterBy="val => filter = val" :filter-by="filterBy" :back="false" :can-create="canCreateShop"></app-sub-header>
    </div>
    <div v-show="isReady">
    <div v-if="empty_view">
      <div class="post d-flex flex-column-fluid" id="kt_post" v-if="!getFilteredShops.length">
        <div id="kt_content_containerr" class="container-xxl">
          <div v-show="status && !getFilteredShops.length">
            <div class="card-body">
              <div class="card-px text-center pt-15 pb-15">
                <h2 class="fs-2x fw-bolder mb-0">{{ $t('shop.no_shop_found') }}</h2>
              </div>
              <div class="text-center pt-8">
                <img src="/assets/media/illustrations/sketchy-1/illustration1-custom.svg?v=2" alt=""
                  class="mw-100 h-150px h-sm-225px" />
              </div>
            </div>
          </div>
          <div class="" v-show="!status && !getFilteredShops.length">
            <div class="card-body">
              <div class="card-px text-center pt-15 pb-15">
                <h2 class="fs-2x fw-bolder mb-0">{{ $t('shop.no_shop_found') }}</h2>
              </div>
              <div class="text-center pt-8">
                <img src="/assets/media/illustrations/sketchy-1/illustration1-custom.svg?v=2" alt=""
                  class="mw-100 h-150px h-sm-225px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="post d-flex flex-column-fluid" id="kt_postt" v-else>
        <div id="kt_content_container" class="container-xxl">
          <div>
            <div id="contenu">
              <div class="row g-6 g-xl-9">
                <div class="col-md-6 col-xl-4" v-for="shop in getFilteredShops" :key="shop?.id">
                  <router-link :to="'shops/' + shop?.id + '/view'" class="shop-card text-decoration-none">
                    <!-- Bordure gauche colorée -->
                    <div class="shop-card-side-bar" :class="shop.archive ? 'bar-archived' : 'bar-active'"></div>

                    <!-- Contenu -->
                    <div class="shop-card-content">
                      <!-- Initiale -->
                      <div class="shop-card-initial" :class="shop.archive ? 'initial-archived' : 'initial-active'">
                        {{ shop.name?.charAt(0)?.toUpperCase() || '?' }}
                      </div>

                      <!-- Infos -->
                      <div class="shop-card-info-block">
                        <div class="shop-card-name">{{ shop.name }}</div>
                        <div class="shop-card-meta">
                          <i class="bi bi-telephone me-1"></i>{{ shop.phone || '—' }}
                        </div>
                        <div class="shop-card-meta">
                          <i class="bi bi-geo-alt me-1"></i>{{ shop.country ? shop.country.name + ', ' : '' }}{{ shop.address || '—' }}
                        </div>
                        <!-- points rouges : ce qui demande une action dans cette boutique -->
                        <div v-if="alertParts(shop.id).length" class="shop-card-alert">
                          <span class="shop-card-alert-dot"></span>{{ alertParts(shop.id).join(' · ') }}
                        </div>
                      </div>

                      <!-- Badge statut icône seule -->
                      <div class="shop-card-badge" :class="shop.archive ? 'badge-archived' : 'badge-active'">
                        <i :class="shop.archive ? 'bi bi-lock-fill' : 'bi bi-check-circle-fill'"></i>
                      </div>
                    </div>
                  </router-link>
                </div>

                <!--end::Col-->
                <!--end::Col-->
              </div>
              <!--end::Row-->
            </div>
            <!--end::Tab pane-->
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="container-xxl" v-show="!isReady">
      <div class="row loader text-center">
        <Loader />
      </div>
    </div>

    <div class="modal fade" id="createModal" data-backdrop="static" tabindex="-1" role="dialog"
      aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="createShopData" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('button.add') }}</h5>

              <!--begin::Close-->
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                      fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                      fill="currentColor" />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>

              <!--end::Close-->
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 my-1">
                  <div class="d-flex flex-column fv-row">
                    <!--begin::Label-->
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span class="required">{{ $t('shop.name') }}</span>
                    </label>
                    <!--end::Label-->
                    <input class="form-control form-control-solid " :placeholder="$t('shop.name_placeholder')" v-model="formCreateData.name" required />
                  </div>
                </div>


                <div class="col-12 my-1">
                  <div class="d-flex flex-column fv-row">
                    <!--begin::Label-->
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span class="required">{{ $t('shop.address') }}</span>
                    </label>
                    <!--end::Label-->
                    <input class="form-control form-control-solid " :placeholder="$t('shop.address_placeholder')"
                           v-model="formCreateData.address" required />
                  </div>
                </div>
                <InputTel
                    name="newShopPhone"
                    type="text"
                    :label="$t('shop.phone')"
                    containerClass="col-md-12 my-1"
                    labelClass="fs-6 fw-bold mb-2"
                    :inputClass="'form-control form-control-solid'"
                    v-model:phone="phone_number"
                    v-model:phone-code="dialCode"
                    :placeholder="$t('enter_phone')"
                    :isRequired="true" />
<!--                <div class="col-12 my-1">-->
<!--                  <div class="d-flex flex-column fv-row mb-4">-->
<!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                    <label class="fs-6 fw-bold mb-2">-->
<!--                      <span class="">{{ $t('shop.stores') }}</span>-->
<!--                    </label>-->
<!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    <div class="d-flex align-items-stretch h-100">-->
<!--                      <div class="flex-grow-1">-->
<!--                        <select name="stores[]"-->
<!--                                v-model="formCreateData.stores"-->
<!--                                data-control="select2"-->
<!--                                data-dropdown-parent="#createModal" data-search="true"-->
<!--                                multiple="multiple"-->
<!--                                data-allow-clear="true"-->
<!--                                :data-placeholder="$t('shop.stores_placeholder')" class="form-select  kt_select2 form-control form-control-solid">-->
<!--                          <option v-for="store in getStores" :key="store?.id" :value="store?.id">{{ store.name }}-->
<!--                          </option>-->
<!--                        </select>-->
<!--                      </div>-->
<!--                      <div data-bs-target="#createStoreModal" data-bs-toggle="modal"-->
<!--                           class="btn btn-light d-flex align-items-center justify-content-center border border-start-0" id="basic-addon2">-->
<!--                        <i class="fas fa-plus fs-4"></i>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="col-6 d-flex align-items-stretch my-1">-->
<!--                  <div class="d-flex flex-column mt-auto fv-row">-->
<!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                    <label class="d-flex align-items-center fs-6 fw-bold">-->
<!--                      <span class="">{{ $t('shop.prefix') }} </span>-->
<!--                    </label>-->
<!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    <input class="form-control form-control-solid " :placeholder="$t('shop.prefix_placeholder')"-->
<!--                           v-model="formCreateData.prefix"/>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-4 d-flex align-items-stretch my-1">-->
<!--                  <div class="d-flex flex-column mt-auto fv-row">-->
<!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
<!--                    <label class="d-flex align-items-center fs-6 fw-bold">-->
<!--                      <span class="">{{ $t('shop.transfer_prefix') }} </span>-->
<!--                    </label>-->
<!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
<!--                    <input class="form-control form-control-solid " :placeholder="$t('shop.transfer_prefix_placeholder')"-->
<!--                           v-model="formCreateData.transfer_number"/>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
              <button type="submit" class="btn btn-sm btn-primary" :disabled="isLoading">
                <span class="indicator-label" v-if="!isLoading">{{ $t('button.save') }}</span>
                <span class="" v-else>{{ $t('loading') }}
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="createStoreModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('store.create.title') }}</h5>
            <!--begin::Close-->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-target="#createModal" data-bs-toggle="modal" aria-label="Close">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>

            <!--end::Close-->
          </div>
          <div class="modal-body">
            <!--begin:Form-->
            <form @submit.prevent="createStoreData" id="kt_modal_new_target_form" class="form">

              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('store.form.name') }}</span>
                  <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                     title="Specify a target name for future usage and reference"></i>
                </label>
                <!--end::Label-->
                <input type="text" class="form-control form-control-solid" v-model="formStore.name"
                       :placeholder="$t('store.form.name')" required />
              </div>

              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('store.form.address') }}</span>
                  <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                     title="Veuillez bien renseigner ce champ"></i>
                </label>
                <input type="text" class="form-control form-control-solid" v-model="formStore.address"
                       :placeholder="$t('store.form.address')" required />
              </div>

              <InputTel
                  name="newShopStorePhone"
                  type="text"
                  :label="$t('store.form.telephone')"
                  containerClass="d-flex flex-column mb-8 fv-row"
                  labelClass="fs-6 fw-bold mb-2"
                  :inputClass="'form-control form-control-solid'"
                  v-model:phone="formStore.phone"
                  v-model:phone-code="dialCode"
                  :placeholder="$t('enter_phone')"
                  :isRequired="true" />


              <div class="row">
                <div class="col-6">
                  <div class="d-flex flex-column mb-8 fv-row">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span>{{ $t('store.form.prefixe') }}</span>
                    </label>
                    <input type="text" required class="form-control form-control-solid" v-model="formStore.prefixe"
                           :placeholder="$t('store.placeholder.prefixe')" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="d-flex flex-column mb-8 fv-row">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span>{{ $t('store.form.transfer_number') }}</span>
                    </label>
                    <input type="text" required class="form-control form-control-solid" v-model="formStore.transfer_number"
                           :placeholder="$t('store.placeholder.transfer_number')" />
                  </div>
                </div>

              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light" data-bs-target="#createModal" data-bs-toggle="modal">{{
                    $t('button.close')
                  }}</button>
                <button type="submit" class="btn btn-sm  btn-primary" :disabled="isLoading">
                  <span class="indicator-label" v-if="!isLoading">{{ $t('button.save') }}</span>
                  <span class="" v-else>{{ $t('loading') }}
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AppSubHeader from "@/views/Shop/partials/AppSubHeaderIndex";
import {VueTelInput} from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import {mapActions, mapGetters} from "vuex";
import InputTel from "@/components/InputTel.vue";
import Loader from "@/components/Loader.vue";

export default {
  name: "Index",
  components: {InputTel, AppSubHeader, VueTelInput, Loader},
  data() {
    return {
      title: i18n.global.t('breadcrumbs.shop.shops'),
      formCreateData: {
        name: '',
        invoice_number: '',
        transfer_number: '',
        phone: '',
        address: '',
        stores : [],
        online: true,
        archive: false,
        prefix: ''
      },
      formStore: {
        id: '',
        name: '',
        address: '',
        phone: '',
        etat: 'active',
        prefixe: '',
        transfer_number: '',
      },
      dialCode:'',
      phone_number: null,
      empty_view: false,
      isLoading: false,
      status: "all",
      search: null,
      listShops: [],
      filter: "all",
      filterBy: [
        {name: 'All', value: "all", translate: 'shop.all_shops'},
        {name: 'Inarchive', value: "false", translate: 'shop.active'},
        {name: 'Archive', value: "true", translate: 'shop.inactive'}
      ],
      isReady: false
    }
  },

  computed: {
    ...mapGetters('countries', ['getCountries']),
    ...mapGetters('shop', ['getShops', 'getShopAlerts']),
    ...mapGetters('store', ['getStores']),
    ...mapGetters('society', ['canCreateShop']),

    getFilteredShops() {
      let filterMatch = []
      if(this.filter == 'all'){
        filterMatch = this.getShops
      }else{
        filterMatch = this.getShops.filter(shop => shop.archive == (this.filter == "true"))
      }

      if (this.search) {
        return filterMatch.filter(shop => {
          const nameMatch = this.search ? this.search.toLowerCase().split(" ").every(x => shop.name.toLowerCase().includes(x)) : true;
          return nameMatch;
        });
      }
      return filterMatch;
    },

    options(){
      return {
        placeholder: i18n.global.t('enter_phone'),
        showDialCode : false
      }
    },

    dropdownOptions(){
      return {
        showDialCodeInSelection: true,
        showDialCodeInList: true,
        showFlags: true
      }
    }
  },

  async mounted() {
    this.isReady = false
    this.loadCountries()
    if (this.$hasModule('pos.warehouse')) {
      this.loadStore({status: "all", search: null})
    }
    await Promise.all([this.initShops(), this.fetchSociety()])
    this.empty_view = true
    this.initSelect()
    this.isReady = true
  },

  methods: {
    // textes des alertes d'une boutique (ruptures, transferts à valider, crédits en retard)
    alertParts(shopId) {
      const alert = this.getShopAlerts[shopId]
      if (!alert) return []
      return [
        alert.ended_products ? this.$t('shop_alerts.ended', { count: alert.ended_products }) : null,
        alert.transfers_to_validate ? this.$t('shop_alerts.transfers', { count: alert.transfers_to_validate }) : null,
        alert.overdue_credits ? this.$t('shop_alerts.credits', { count: alert.overdue_credits }) : null,
      ].filter(Boolean)
    },

    ...mapActions('countries', ['loadCountries']),
    ...mapActions('shop', ['loadShops']),
    ...mapActions('society', ['fetchSociety', 'createShopForSociety']),

    ...mapActions('store', ['loadStore', 'createStore']),

    openCreateModal() {

      $('#createModal').modal('toggle')
    },

    openCreateStoreModal() {
      $('#createStoreModal').modal('toggle')
    },

    async initShops() {
      let response = await this.loadShops({status: this.status, search: this.search})
      this.listShops = response.shops
    },

    initSelect(){
      $("body .kt_select2").select2()

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'active':
            this.formCreateData.archive = !!e.target.value
            break;
          case 'status':
            this.status = !!e.target.value
            break;
          case 'stores[]':
            let addStores = [];
            for (var k = 0, kLen = e.target.selectedOptions.length; k < kLen; k++) {
              if (e.target.selectedOptions[k].value != '' || e.target.selectedOptions[k].value != undefined) {
                addStores.push(e.target.selectedOptions[k].value);
              }
            }
            this.formCreateData.stores = addStores
            break;
          default:
            break;
        }
      })
    },

    async createShopData() {
      this.isLoading = true

      try {
        const response = await this.createShopForSociety({
          name: this.formCreateData.name,
          address: this.formCreateData.address,
          phone: this.phone_number,
          phone_code: this.dialCode,
        })
        this.isLoading = false
        $('#createModal').modal('toggle')
        window.toastr['success'](i18n.global.t("notification.shop_created"))
        // La création active immédiatement la nouvelle boutique côté serveur
        // (ShopUser::addUserInShop) — rechargement complet pour repartir avec
        // tout le state (permissions, catégories...) scopé sur elle.
        window.location.href = '/admin/shops/' + response?.data?.shop?.id + '/view'

      } catch (err) {
        this.isLoading = false;
      }
    },


    async createStoreData() {

      let response = {};
      this.isLoading = true;
      try {
        response = await this.createStore(this.formStore);
        this.formCreateData.stores?.push(response.data.store.id)
        $('#createStoreModal').modal('toggle')
        window.toastr['success'](i18n.global.t('notification.store.created'))
        this.isLoading = false;
        this.formStore.name = "";
        this.formStore.address = "";
        this.formStore.phone = "";
        this.formStore.prefixe = "";
        this.formStore.transfer_number = "";
        $('#createModal').modal('toggle')
        this.$nextTick(() => {
          this.initSelect()
        })
      } catch (err) {
        this.isLoading = false;
      }
    },

  }
}
</script>

<style scoped>
/* ── Carte boutique — style initiale ── */
.shop-card {
  display: flex;
  align-items: stretch;
  height: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
  margin-bottom: 4px;
}
.shop-card:hover {
  box-shadow: 0 6px 20px rgba(0,0,0,0.12);
  transform: translateY(-2px);
}

/* Bordure gauche colorée */
.shop-card-side-bar {
  width: 5px;
  flex-shrink: 0;
  border-radius: 12px 0 0 12px;
}
.bar-active   { background: var(--kt-primary); }
.bar-archived { background: #f1416c; }

/* Contenu principal */
.shop-card-content {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 24px 20px;
  flex: 1;
  min-width: 0;
}

/* Initiale */
.shop-card-initial {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -1px;
}
/* dégradé à la couleur de la boutique (personnalisation), couleur par défaut sinon */
.initial-active   { background: linear-gradient(135deg, var(--kt-primary-active, #a87840), var(--kt-primary, #0b3d87)); }
.initial-archived { background: linear-gradient(135deg, #a31010, #f1416c); }

/* Bloc infos */
.shop-card-info-block {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.shop-card-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e2130;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.shop-card-alert {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #f1416c;
}
.shop-card-alert-dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f1416c;
  animation: shop-alert-blink 1.1s ease-in-out infinite;
}
@keyframes shop-alert-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.25; }
}
.shop-card-meta {
  font-size: 0.85rem;
  color: #a1a5b7;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Badge statut icône seule */
.shop-card-badge {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  align-self: flex-start;
}
.shop-card-badge.badge-active   { background: rgba(80,205,137,0.15); color: #50cd89; }
.shop-card-badge.badge-archived { background: rgba(241,65,108,0.12); color: #f1416c; }

.light-danger {
    color: #f1416c;
    border-color: #fff5f8;
    background-color: #fff5f8;
    font-size: .925rem;
    border-radius: 0.325rem;
    padding: 5px 10px;
}

.light-primary {
    color: #0b3d87;
    border-color: #f1faff;
    background-color: #f1faff;
    font-size: .925rem;
    border-radius: 0.325rem;
    padding: 5px 10px;
}
</style>
